import MKTypography from "components/MKTypography";
//import ReactGA from "react-ga4";
// Material Kit 2 React components
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
// Images
import { Card, CardContent, Button } from "@mui/material";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import Box from "@mui/material/Box";
//import Slider from "@mui/material/Slider";
import { FIND_STRATEGYFOCUSAREAS_BY_MUNICIPALITY, FIND_VOTES_BY_MUNICIPALITY } from "queries";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Focusareaspublic = ({ selectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  const [t] = useTranslation("common");
  const [fareas, setFareas] = useState([]);
  //console.log(setFareas);
  //console.log(selectedKunta);
  //const [limits, setLimits] = useState([25, 25, 25, 25]);
  //const [limitslider, setLimitslider] = useState([25, 50, 75]);
  const [votes, setVotes] = useState([]);
  //const [classs, setClasss] = useState("");
  //["Lapset ja nuoret", "Seniorit", "Liikunta ja vapaa-aika", "Kulttuuri"],
  const sfareassw = useQuery(FIND_STRATEGYFOCUSAREAS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let sfareass = [];
    //console.log(sfareassw);
    //let municipalitiess = [];
    if (sfareassw.data) {
      sfareass = sfareassw.data.findStrategyfocusareasByMunicipality;
      //setOrgans(organss);
      //console.log(sfareass);
      //let secs = sfareass.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsfareas(secs);
      setFareas(sfareass);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sfareassw]);
  const handleVote = () => {
    window.confirm("Sinun on kirjauduttava voidaksesi äänestää");
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function addRow(p) {
    //console.log(p);
    let txt = "";
    for (let i = 0; i < p.length; i++) {
      if (i === 0) {
        txt = p[i];
      } else {
        txt = txt + ", " + p[i];
      }
    }
    return txt;
  }
  function addWeights(p) {
    //console.log(p);
    let txt = "";
    for (let i = 0; i < p.length; i++) {
      if (i === 0) {
        txt = p[i] + " %";
      } else {
        txt = txt + ", " + p[i] + " %";
      }
    }
    return txt;
  }
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategyfocusareaid === p).length;
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("focusareas.header")}
          </MKTypography>
          <MKTypography variant="body1" gutterBottom>
            {t("focusareas.text")}
          </MKTypography>
          <br />
        </CardContent>
      </Card>
      <MKTypography variant="h4" gutterBottom>
        {t("focusareas.header")}
      </MKTypography>
      {fareas.length === 0 && <MKTypography>{t("focusareas.nosaved")}</MKTypography>}
      {fareas.map((item) => (
        <Card key={item.id} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>
              {addRow(item.weightclass)}: {addWeights(item.weights)}
            </MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Focusareaspublic;
